import {
  Row,
  Col,
  Card,
  Button,
  Input,
  Form,
  Skeleton,
  Image,
  Select,
  Table,
  Tooltip,
  Tag,
  Modal,
  InputNumber,
  Divider,
} from "antd";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";
import apiPath from "../../../constants/apiPath";
import { Badge } from "antd";
import moment from "moment";
import { PRICE } from "../../../constants/conts";
import notfound from "../../../assets/images/not_found.png";
import ShowTotal from "../../../components/ShowTotal";
import ConfirmationBox from "../../../components/ConfirmationBox";
import { ViewAttribute } from "./ViewAttribute";
import lang from "../../../helper/langHelper";
import DeleteModal from "../../../components/DeleteModal";
import MultipleImageUpload from "../../../components/MultipleImageUpload";
import SingleImageUpload from "../../../components/SingleImageUpload";

function ViewProduct() {
  const generateRandomSKU = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let sku = "";

    const randomNum = Math.floor(Math.random() * (15 - 4 + 1)) + 4;

    for (let i = 0; i < randomNum; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      sku += characters.charAt(randomIndex);
    }

    return sku;
  };

  const sectionName = "Product Variant";
  const routeName = "product/catalogue";

  const api = {
    attrList: apiPath.listVendorProduct,
    listProductVariant: apiPath.listProductVariant,
    view: apiPath.viewProduct,
    categoryAttribute: apiPath.common.attributes,
    addVariant: apiPath.listProductVariant,
    status: apiPath.listProductVariant + `/status`,
  };

  const params = useParams();
  const [form] = Form.useForm();
  const [categoryAttribute, setCategoryAttribute] = useState([]);
  const [attrLoading, setAttrLoading] = useState(false);
  const { request } = useRequest();
  const [list, setList] = useState();
  const [loading, setLoading] = useState(false);
  const { showConfirm } = ConfirmationBox();
  const [attrList, setAttrList] = useState([]);
  const [variantList, setVariantList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [deleteModal, showDeleteModal] = useState(false);
  const [editVariant, showEditVariant] = useState(false);
  const [selected, setSelected] = useState();
  const [selectedAttribute, setSelectedAttribute] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [skuu, setSku] = useState(() => generateRandomSKU());
  const navigate = useNavigate();
  const viewAttribute = (id) => {
    if (id) {
      setVisible(true);
    }
  };

  const onDelete = (id) => {
    request({
      url: api.listProductVariant + "/" + id,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchData = (id) => {
    request({
      url: api.view + "/" + id,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setList(data.data);
        getCategoryAttributeList(
          data &&
            data.data &&
            data.data.category_id &&
            data.data.category_id._id
        );
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const getCategoryAttributeList = (category_id) => {
    request({
      url: api.categoryAttribute + `/${category_id}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setCategoryAttribute(data.data);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const OnAttributeUpdate = (values) => {
    if (selectedAttribute.length === 0)
      return ShowToast("At least one attribute must be selected", Severty.INFO);
    onUpdate();
  };

  const onUpdate = (images) => {
    const {
      price,
      number_of_benchmark,
      number_of_inventory,
      number_of_points,
    } = form.getFieldsValue();
    const payload = {
      price,
      number_of_benchmark,
      number_of_inventory,
      number_of_points,
    };
    payload.product_id = params.id;
    payload.attribute = selectedAttribute;
    setAttrLoading(true);
    request({
      url: api.addVariant,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setAttrLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          setRefresh((prev) => !prev);
          form.resetFields();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setAttrLoading(false);
      },
    });
  };

  const OnSelect = (value, item, index) => {
    const newArray = [...selectedAttribute];
    newArray[index] = {
      name: item.name,
      type: item.type,
      value,
      is_image_require: item.is_image_require,
    };
    setSelectedAttribute(newArray);
    console.log(value, item, index, newArray);
  };

  const columns = [
    {
      title: "Thumbnail",
      dataIndex: "thumbnail",
      key: "thumbnail",
      render: (_, { thumbnail, images }) => (
        <Image
          width={50}
          src={thumbnail ? thumbnail : images ? images[0] : notfound}
        />
      ),
    },
    {
      title: "name",
      dataIndex: "product_id",
      key: "product_id",
      render: (_, { product_id }) => {
        return product_id ? (
          <span className="cap">{product_id?.name}</span>
        ) : (
          "-"
        );
      },
    },
    {
      title: `price (${PRICE})`,
      dataIndex: "price",
      key: "price",
      render: (_, { price }) => {
        return price ? <span className="cap">{price}</span> : "-";
      },
    },
    {
      title: "number of benchmark",
      dataIndex: "number_of_benchmark",
      key: "number_of_benchmark",
      render: (_, { number_of_benchmark }) => {
        return number_of_benchmark ? (
          <span className="cap">{number_of_benchmark}</span>
        ) : (
          "-"
        );
      },
    },
    {
      title: "number_of_inventory",
      dataIndex: "number_of_inventory",
      key: "number_of_inventory",
      render: (_, { number_of_inventory }) => {
        return number_of_inventory ? (
          <span className="cap">{number_of_inventory}</span>
        ) : (
          "-"
        );
      },
    },
    {
      title: "number_of_points",
      dataIndex: "number_of_points",
      key: "number_of_points",
      render: (_, { number_of_points }) => {
        return number_of_points ? (
          <span className="cap">{number_of_points}</span>
        ) : (
          "-"
        );
      },
    },
    // {
    //   title: "complexity_level",
    //   dataIndex: "complexity_level",
    //   key: "complexity_level",
    //   render: (_, { complexity_level }) => {
    //     return complexity_level ? (
    //       <span className="cap">{complexity_level}</span>
    //     ) : (
    //       "-"
    //     );
    //   },
    // },
    {
      title: "Attributes",
      dataIndex: "attribute_value",
      key: "attribute_value",
      render: (_, { attribute }) => {
        return attribute ? (
          <span className="cap">
            {attribute.map((item) => (
              <p>{`${item.name} => ${item.value}`}</p>
            ))}
          </span>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      render: (_, { is_active, _id }) => {
        let color = is_active ? "green" : "red";
        return (
          <a>
            <Tag
              onClick={(e) =>
                showConfirm({
                  record: _id,
                  path: api.status,
                  onLoading: () => setAttrLoading(true),
                  onSuccess: () => setRefresh((prev) => !prev),
                })
              }
              color={color}
              key={is_active}
            >
              {is_active ? "Active" : "Inactive"}
            </Tag>
          </a>
        );
      },
    },
    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("DD-MMM-YYYY");
      },
    },
    {
      title: "Action",
      fixed: "right",
      render: (_, record) => {
        return (
          <>
            <Tooltip
              title={"View " + sectionName}
              color={"purple"}
              key={"view" + routeName}
            >
              <Button
                title="View"
                className="edit-cls btnStyle primary_btn"
                onClick={(e) => {
                  setSelected(record);
                  viewAttribute(record._id);
                }}
              >
                <i className="fa fa-light fa-eye"></i>
              </Button>
            </Tooltip>    
            <Tooltip
              title={"Edit Product Variant"}
              color={"purple"}
              key={"edit_vendor_product"}
            >
              <Button
                title="Edit"
                className="edit-cls btnStyle primary_btn"
                onClick={(e) => {
                  setSelected(record);
                  showEditVariant(true);
                }}
              >
                <i className="fa fa-light fa-edit"></i>
              </Button>
            </Tooltip>
            <Tooltip title={"Delete Product Variant"} color={"purple"} key={"delete_vendor_product"}>
              <Button title="Delete" className="delete-cls btnStyle primary_btn" onClick={(e) => { setSelected(record); showDeleteModal(record._id); }}>
                <i className="fa fa-trash"></i>
              </Button>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const fetchVariant = () => {
    request({
      url: api.listProductVariant + `/${params.id}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setAttrLoading(false);
        setVariantList(data?.docs);
        setPagination((prev) => ({ current: 1, total: data?.totalDocs }));
      },
      onError: (error) => {
        setAttrLoading(false);
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    fetchVariant();
  }, [refresh]);

  useEffect(() => {
    setLoading(true);
    fetchData(params.id);
  }, []);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24} xxl={16}>
          <Card title={sectionName + " Details"} style={{ height: "100%" }}>
            <Row gutter={16}>
              <Col span={12} xs={24} md={24}>
                {loading ? (
                  [1, 2, 3, 4].map((item) => <Skeleton active key={item} />)
                ) : (
                  <div className="view-main-list">
                    <div className="view-inner-cls">
                      <h5>Thumbnail:</h5>
                      <h6>
                        <Image
                          width={60}
                          src={list?.thumbnail ? list?.thumbnail : notfound}
                        />
                      </h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Name:</h5>
                      <h6>
                        <span className="cap">
                          {list?.name ? list?.name : "-"}
                        </span>
                      </h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Category:</h5>
                      <h6>
                        <span className="cap">
                          {list?.category_id && list?.category_id.name
                            ? list?.category_id.name
                            : "-"}
                        </span>
                      </h6>
                    </div>
                    <div className="view-inner-cls">
                      <h5>Challenge:</h5>
                      <h6>
                        <span className="cap">
                          {list?.challenge_id && list?.challenge_id.name
                            ? list?.challenge_id.name
                            : "-"}
                        </span>
                      </h6>
                    </div>

                  
                   
                

                    <div className="view-inner-cls">
                      <h5>Description:</h5>
                      <h6>
                        {list?.description ? (
                          <p
                            dangerouslySetInnerHTML={{
                              __html: list?.description,
                            }}
                          ></p>
                        ) : (
                          "-"
                        )}
                      </h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Status:</h5>
                      <h6>
                        {list?.is_active ? (
                          <Badge status="success" text="Active" />
                        ) : (
                          <Badge status="error" text="InActive" />
                        )}
                      </h6>
                    </div>

                    {list && list?.image?.length > 0 ? (
                      <div className="view-inner-cls other-image productDetail">
                        <h5>Other Images:</h5>
                        <div className="other-img-inr">
                          {list?.image.map((item, index) => (
                            <div key={index} className="imageradius mt-1">
                              <Image width={60} src={item} />
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : null}

                    {list && list?.parent_id != null ? (
                      <div className="view-inner-cls">
                        <h5>Attribute Combination:</h5>
                        <Row className="text-right">
                          <Col span={24}>
                            {list &&
                              list?.attribute &&
                              list?.attribute.length > 0 &&
                              list?.attribute.map((item, index) => (
                                <h6 className="cap mt-1">
                                  {index + 1}) {item.name} : {item.value} &nbsp;
                                </h6>
                              ))}
                          </Col>
                        </Row>
                      </div>
                    ) : null}

                    <div className="view-inner-cls">
                      <h5>Created On:</h5>
                      <h6>
                        {list?.created_at
                          ? moment(list?.created_at).format("DD-MMM-YYYY")
                          : "-"}
                      </h6>
                    </div>

                    <div className="view-inner-cls float-right">
                      <Link
                        className="ant-btn ant-btn-primary"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </Link>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </Card>
        </Col>

        <Col span={24} xxl={8}>
          <Card
            className="attributeCard"
            size="small"
            title="Attributes Details"
            style={{ height: "100%" }}
          >
            {loading ? (
              [1, 2, 3].map((item) => <Skeleton active key={item} />)
            ) : (
              <Form
                form={form}
                className="edit-page-wrap"
                onFinish={OnAttributeUpdate}
                autoComplete="off"
                layout="verticle"
                name="attribute_form"
                initialValues={{ sku: skuu }}
                style={{ height: "100%" }}
              >
                <div className="scrollable-card">
                  <Row gutter={[12,0]}>
                    <Col span={24} sm={12}>
                      <Form.Item
                        label={<> {"Number Of Inventory"}</>}
                        name="number_of_inventory"
                        rules={[
                          {
                            required: true,
                            message: "Number Of Inventory is required",
                          },
                          {
                            validator: (_, value) => {
                              if (value <= 0) {
                                return Promise.reject(
                                  "Number Of Inventory must be greater than zero"
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <InputNumber
                          autoComplete="off"
                          placeholder={`Enter Number Of Inventory`}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={24} sm={12}>
                      <Form.Item
                        label={<> {"Number Of Benchmark"}</>}
                        name="number_of_benchmark"
                        rules={[
                          {
                            required: true,
                            message: "Number Of Benchmark is required",
                          },
                          {
                            validator: (_, value) => {
                              if (value <= 0) {
                                return Promise.reject(
                                  "Number Of Benchmark must be greater than zero"
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <InputNumber
                          autoComplete="off"
                          placeholder={`Enter Number Of Benchmark`}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={12} xs={12} sm={12} md={12}>
                      <Form.Item
                        label={`Price (${PRICE})`}
                        className="attribute-elt"
                        name={`price`}
                        rules={[
                          { required: true, message: "Missing the price!" },
                        ]}
                      >
                        <InputNumber
                          type="number"
                          maxLength={10}
                          placeholder={`Enter product variation Price (${PRICE})`}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24} sm={12}>
                      <Form.Item
                        label={<> {"Number Of Points"}</>}
                        name="number_of_points"
                        rules={[
                          {
                            required: false,
                            message: "Number Of Points is required",
                          },
                          {
                            validator: (_, value) => {
                              if (value && value <= 0) {
                                return Promise.reject(
                                  "Number Of Points must be greater than zero"
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <InputNumber
                          autoComplete="off"
                          placeholder={`Enter Number Of Points`}
                        />
                      </Form.Item>
                    </Col>
                    <Divider />
                    {categoryAttribute.length > 0
                      ? categoryAttribute.map((item, index) => (
                          <Col span={24} xs={24} sm={24} md={24}>
                            <Form.Item
                              hidden
                              className="attribute-elt"
                              name={`attribute_id_${item.name}`}
                            >
                              <Input defaultValue={item.name}></Input>
                            </Form.Item>

                            <Form.Item
                              className="attribute-elt"
                              name={`attribute_value_${item.name}`}
                              rules={[
                                {
                                  required: item.is_mandatory,
                                  message: `${item.name} is required`,
                                },
                              ]}
                              label={<span className="cap">{item.name}</span>}
                            >
                              <Select
                                placeholder={
                                  <span className="cap">{`Select ${item.name} Attribute`}</span>
                                }
                                onChange={(value) =>
                                  OnSelect(value, item, index)
                                }
                              >
                                {item.options && item.options.length > 0
                                  ? item.options.map((itm, key) => (
                                      <option key={key} value={itm}>
                                        <span className="cap">{itm}</span>
                                      </option>
                                    ))
                                  : null}
                              </Select>
                            </Form.Item>
                          </Col>
                        ))
                      : null}
                  </Row>
                </div>

                <Form.Item className="btn-row">
                  <Button
                    type=" mt-1"
                    className="edit-cls btnStyle primary_btn"
                    loading={attrLoading}
                    htmlType="submit"
                  >
                    Submit Variant
                  </Button>
                </Form.Item>
              </Form>
            )}
          </Card>
        </Col>
      </Row>

      <Card className="mt-3" title="Product Variant(s)">
        <div className="tabled">
          <Row gutter={[24, 0]}>
            <Col xs="24" xl={24}>
              <h4 className="text-right mb-1">
                {pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}
              </h4>
              <div className="table-responsive customPagination">
                <Table
                  loading={attrLoading}
                  columns={columns}
                  dataSource={variantList}
                  pagination={{
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                  }}
                  className="ant-border-space"
                />
              </div>
            </Col>
          </Row>
        </div>
      </Card>

      {visible && (
        <ViewAttribute
          show={visible}
          hide={() => {
            setVisible(false);
          }}
          data={selected}
        />
      )}

      {deleteModal && (
        <DeleteModal
          reasons={[]}
          title={lang("Delete Variant")}
          subtitle={lang(
            `Are you sure you want to Delete this Variant?`
          )}
          show={deleteModal}
          hide={() => {
            showDeleteModal(false);
          }}
          onOk={() => onDelete(selected?._id)}
        />
      )}
      {editVariant && (
        <EditVariant
          show={editVariant}
          hide={() => {
            showEditVariant(false);
            setSelected()
          }}
          data={selected}
          api={api}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </>
  );
}

export default ViewProduct;



const EditVariant = ({ show, hide, refresh  , data,api}) => {
  const [image, setImage] = useState();
  const [form] = Form.useForm();
  const [pthumbnail, setThumbnail] = useState();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/avif",
    "image/webp",
  ];

  useEffect(() => {
    if (!data) return;
    console.log(data); 
    form.setFieldsValue({
      ...data,
      category_id: data?.category_id?._id,
    });

    setImage(data.images);
    setThumbnail(data.thumbnail);
    
  }, [data]);


 

  const onOk = (values) => {
    const payload = { };
    if (image?.length > 0) payload.images = image;
    payload.thumbnail = pthumbnail ? pthumbnail : "";

    request({
      url: api.addVariant + "/" +data?._id,
      method: "PUT",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleImage = (data) => {
    data.length > 0 ? setThumbnail(data[0].url) : setThumbnail("");
  };

  const handleMultImage = (value) => {
    setImage((prev) => {
      return value.map((item) => {
        return item.url;
      });
    });
  };
  return (
    <Modal
      // width={500}
      open={show}
      title={`Image Upload`}
      okText="Submit"
      onCancel={hide}
      okButtonProps={{
        onClick: onOk,
      }}
      cancelButtonProps={{
        style: { backgroundColor: "red !important" },
      }}
      cancelText={"Cancel"}
    >
      <div className="mt-1 ms-2">
        <>
          <Col span={24}>
            <Form.Item
              className=""
              rules={[
                {
                  validator: (_, value) => {
                    if (value !== undefined && value?.length > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Thumbnail is required"));
                  },
                },
              ]}
              label={"Upload Thumbnail"}
              name="thumbnail"
            >
              <SingleImageUpload
                value={pthumbnail}
                fileType={FileType}
                imageType={"Thumbnail"}
                btnName={"Thumbnail"}
                onChange={(data) => handleImage(data)}
                isDimension={false}
                setLoading={setLoading}
              />
            </Form.Item>
   
            {
              <div className="mt-2 add-img-product">
                {" "}
                {pthumbnail ? (
                  <Image width={120} src={pthumbnail ?? notfound}></Image>
                ) : (
                  ""
                )}{" "}
              </div>
            }
          </Col>
          <Col span={24} md={24}>
            <Form.Item
              className="upload_wrap img-uploaded"
              name={"images"}
              label={"Upload Gallery Image"}
              getValueFromEvent={(event) => {
                return event.map((item) => item.thumbUrl).join(",");
              }}
            >
              <MultipleImageUpload
                value={image}
                data={image}
                fileType={FileType}
                imageType={"product"}
                btnName={"Image"}
                onChange={(data) => handleMultImage(data)}
              />
            </Form.Item>
            <p className="img-size-details">
              **
              {`${"Images should be all size accepted for best view in gallery image. You can select only"} ${8} ${"images (.gif, .png, .jpeg, .jpg) format files upto 5 MB file size"}`}
              ..!!!
            </p>
          </Col>
        </>
      </div>
    </Modal>
  );
};
